import * as methods from "../constants/methods";
import HandleChannelAddMessageReactionResponse from "./Channel/HandleChannelAddMessageReactionResponse";
import HandleChannelGetMessagesStatsResponse from "./Channel/HandleChannelGetMessagesStatsResponse";
import HandleClientGetDiscoveryResponse from "./Client/HandleClientGetDiscoveryResponse";
import HandleClientGetPromoteResponse from "./Client/HandleClientGetPromoteResponse";
import HandleClientGetRoomHistoryResponse from "./Client/HandleClientGetRoomHistoryResponse";
import HandleClientGetRoomListResponse from "./Client/HandleClientGetRoomListResponse";
import HandleClientGetRoomMessageResponse from "./Client/HandleClientGetRoomMessageResponse";
import HandleClientGetRoomResponse from "./Client/HandleClientGetRoomResponse";
import HandleClientMuteRoomResponse from "./Client/HandleClientMuteRoomResponse";
import HandleClientPinRoomResponse from "./Client/HandleClientPinRoomResponse";
import HandleClientSearchRoomHistoryResponse from "./Client/HandleClientSearchRoomHistoryResponse";
import HandleConnectionSecuringResponse from "./Connection/HandleConnectionSecuringResponse";
import HandleConnectionSymmetricKeyResponse from "./Connection/HandleConnectionSymmetricKeyResponse";
import HandleMessagesDeleteMessageResponse from "./HandleMessagesDeleteMessageResponse";
import HandleMessagesEditMessageResponse from "./HandleMessagesEditMessageResponse";
import HandleRoomAddAdminResponse from "./HandleRoomAddAdminResponse";
import HandleRoomAddMemberResponse from "./HandleRoomAddMemberResponse";
import HandleRoomAvatarGetListResponse from "./HandleRoomAvatarGetListResponse";
import HandleRoomClearMessageResponse from "./HandleRoomClearMessageResponse";
import HandleRoomDeleteResponse from "./HandleRoomDeleteResponse";
import HandleRoomEditResponse from "./HandleRoomEditResponse";
import HandleRoomGetDraftResponse from "./HandleRoomGetDraftResponse";
import HandleRoomGetMemberListResponse from "./HandleRoomGetMemberListResponse";
import HandleRoomKickAdminResponse from "./HandleRoomKickAdminResponse";
import HandleRoomLeftResponse from "./HandleRoomLeftResponse";
import HandleRoomPinMessageResponse from "./HandleRoomPinMessageResponse";
import HandleRoomSendMessageResponse from "./HandleRoomSendMessageResponse";
import HandleRoomSetActionResponse from "./HandleRoomSetActionResponse";
import HandleRoomUpdateDraftResponse from "./HandleRoomUpdateDraftResponse";
import HandleRoomUpdateStatusResponse from "./HandleRoomUpdateStatusResponse";
import HandleRoomUpdateUsernameResponse from "./HandleRoomUpdateUsernameResponse";
import HandleInfoConfigResponse from "./Info/HandleInfoConfigResponse";
import HandlePushLoginTokenResponse from "./Push/HandlePushLoginTokenResponse";
import HandlePushTwoStepVerificationResponse from "./Push/handlePushTwoStepVerificationResponse";
import HandleSignalingAcceptResponse from "./Signaling/HandleSignalingAcceptResponse";
import HandleSignalingCandidateResponse from "./Signaling/HandleSignalingCandidateResponse";
import HandleSignalingGetConfigurationResponse from "./Signaling/HandleSignalingGetConfigurationResponse";
import HandleSignalingGetLogResponse from "./Signaling/HandleSignalingGetLogResponse";
import HandleSignalingLeaveResponse from "./Signaling/HandleSignalingLeaveResponse";
import HandleSignalingOfferResponse from "./Signaling/HandleSignalingOfferResponse";
import HandleSignalingRingingResponse from "./Signaling/HandleSignalingRingingResponse";
import HandleSignalingSessionHoldResponse from "./Signaling/HandleSignalingSessionHoldResponse";
import HandleUserContactsBlockResponse from "./User/HandleUserContactsBlockResponse";
import HandleUserContactsEditResponse from "./User/HandleUserContactsEditResponse";
import HandleUserContactsGetBlockedListResponse from "./User/HandleUserContactsGetBlockedListResponse";
import HandleUserContactsGetListResponse from "./User/HandleUserContactsGetListResponse";
import HandleUserContactsImportResponse from "./User/HandleUserContactsImportResponse";
import HandleUserContactsUnblockResponse from "./User/HandleUserContactsUnblockResponse";
import HandleUserDeleteResponse from "./User/HandleUserDeleteResponse";
import HandleUserInfoResponse from "./User/HandleUserInfoResponse";
import HandleUserIVandGetScoreResponse from "./User/HandleUserIVandGetScoreResponse";
import HandleUserLoginResponse from "./User/HandleUserLoginResponse";
import HandleUserProfileSetBioResponse from "./User/HandleUserProfileSetBioResponse";
import HandleUserProfileSetNicknameResponse from "./User/HandleUserProfileSetNicknameResponse";
import HandleUserProfileUpdateUsernameResponse from "./User/HandleUserProfileUpdateUsernameResponse";
import HandleUserRegisterResponse from "./User/HandleUserRegisterResponse";
import HandleUserTwoStepVerificationRecoverPasswordByAnswersResponse from "./User/HandleUserTwoStepVerificationRecoverPasswordByAnswersResponse";
import HandleUserTwoStepVerificationRecoverPasswordByTokenResponse from "./User/HandleUserTwoStepVerificationRecoverPasswordByTokenResponse";
import HandleUserTwoStepVerificationRequestRecoveryTokenResponse from "./User/HandleUserTwoStepVerificationRequestRecoveryTokenResponse";
import HandleUserTwoStepVerificationVerifyPasswordResponse from "./User/HandleUserTwoStepVerificationVerifyPasswordResponse";
import HandleUserUpdateStatusResponse from "./User/HandleUserUpdateStatusResponse";
import HandleUserVerifyResponse from "./User/HandleUserVerifyResponse";
import HandleClientUnsubscribeFromRoomResponse from "./Client/HandleClientUnsubscribeFromRoomResponse";
import HandleClientJoinByUsernameResponse from "./Client/HandleClientJoinByUserName";
import HandleUserContactsDeleteResponse from "./User/HandleUserContactsDeleteResponse";
import HandleChannelUpdateSignatureResponse from "./Channel/HandleChannelUpdateSignatureResponse";
import HandleChannelUpdateReactionStatusResponse from "./Channel/HandleChannelUpdateReactionStatusResponse";
import HandleChannelRevokeLinkResponse from "./Channel/HandleChannelRevokeLinkResponse";
import HandleChannelAvatarAddResponse from "./Channel/HandleChannelAddAvatarResponse";
import HandleGroupAvatarAddResponse from "./Group/HandleGroupAddAvatarResponse";
import HandleUserAddAvatarResponse from "./User/HandleUserAddAvatarResponse";
import HandleGroupChangeMemberRightsResponse from "./Group/HandleGroupChangeMemberRightsResponse";
import HandleClientGetPollResponse from "./Client/HandleClientGetPollResponse";
import HandleInfoUpdateResponse from "./Info/HandleInfoUpdateResponse";
import HandleStoryGetStoriesResponse from "./Story/HandleStoryGetStoriesResponse";
import HandleStoryUserAddNewResponse from "./Story/HandleStoryUserAddNewResponse";
import HandleStoryAddViewResponse from "./Story/HndleStoryAddViewResponse";
import HandleStoryGetOwnStoryViewsResponse from "./Story/HandleStoryGetOwnViewsResponse";
import HandleStoryDeleteStoryResponse from "./Story/HandleStoryDeleteStoryResponse";
import HandleErrorResponse from "./HandleErrorResponse";
import HandleClientResolveUsernameResponse from "./Client/HandleClientResolveUsernameResponse";
import HandleUserAvatarDeleteResponse from "./User/HandleUserAvatarDeleteResponse";
import HandleClientRoomChangeOwner from "./Client/HandleClientRoomChangeOwner";
import HandleClientRoomMemberSearchResponse from "./Client/HandleClientRoomMemberSearchResponse";

const handlerTable: { [key: number]: any } = {
  // [methods.BILL_INQUIRY_MCI_RESPONSE]: HandleBillInquiryMciResponse,
  // [methods.BILL_INQUIRY_TELECOM_RESPONSE]: HandleBillInquiryTelecomResponse,
  [methods.CHANNEL_ADD_ADMIN_RESPONSE]: HandleRoomAddAdminResponse,
  [methods.CHANNEL_ADD_MEMBER_RESPONSE]: HandleRoomAddMemberResponse,
  [methods.CHANNEL_ADD_MESSAGE_REACTION_RESPONSE]: HandleChannelAddMessageReactionResponse,
  // [methods.CHANNEL_ADD_MODERATOR_RESPONSE]: HandleChannelAddModeratorResponse,
  [methods.CHANNEL_AVATAR_ADD_RESPONSE]: HandleChannelAvatarAddResponse,
  // [methods.CHANNEL_AVATAR_DELETE_RESPONSE]: HandleChannelAvatarDeleteResponse,
  [methods.CHANNEL_AVATAR_GET_LIST_RESPONSE]: HandleRoomAvatarGetListResponse,
  // [methods.CHANNEL_CHECK_USERNAME_RESPONSE]: HandleChannelCheckUsernameResponse,
  [methods.CHANNEL_CREATE_RESPONSE]: HandleRoomAddMemberResponse,
  [methods.CHANNEL_DELETE_MESSAGE_RESPONSE]: HandleMessagesDeleteMessageResponse,
  [methods.CHANNEL_DELETE_RESPONSE]: HandleRoomDeleteResponse,
  [methods.CHANNEL_EDIT_MESSAGE_RESPONSE]: HandleMessagesEditMessageResponse,
  [methods.CHANNEL_EDIT_RESPONSE]: HandleRoomEditResponse,
  [methods.CHANNEL_GET_DRAFT_RESPONSE]: HandleRoomGetDraftResponse,
  [methods.CHANNEL_GET_MEMBER_LIST_RESPONSE]: HandleRoomGetMemberListResponse,
  [methods.CHANNEL_GET_MESSAGES_STATS_RESPONSE]: HandleChannelGetMessagesStatsResponse,
  [methods.CHANNEL_KICK_ADMIN_RESPONSE]: HandleRoomKickAdminResponse,
  [methods.CHANNEL_KICK_MEMBER_RESPONSE]: HandleRoomLeftResponse,
  // [methods.CHANNEL_KICK_MODERATOR_RESPONSE]: HandleChannelKickModeratorResponse,
  [methods.CHANNEL_LEFT_RESPONSE]: HandleRoomLeftResponse,
  [methods.CHANNEL_PIN_MESSAGE_RESPONSE]: HandleRoomPinMessageResponse,
  // [methods.CHANNEL_REMOVE_USERNAME_RESPONSE]: HandleChannelRemoveUsernameResponse,
  [methods.CHANNEL_REVOKE_LINK_RESPONSE]: HandleChannelRevokeLinkResponse,
  [methods.CHANNEL_SEND_MESSAGE_RESPONSE]: HandleRoomSendMessageResponse,
  [methods.CHANNEL_UPDATE_DRAFT_RESPONSE]: HandleRoomUpdateDraftResponse,
  [methods.CHANNEL_UPDATE_REACTION_STATUS_RESPONSE]: HandleChannelUpdateReactionStatusResponse,
  [methods.CHANNEL_UPDATE_SIGNATURE_RESPONSE]: HandleChannelUpdateSignatureResponse,
  [methods.CHANNEL_UPDATE_USERNAME_RESPONSE]: HandleRoomUpdateUsernameResponse,
  [methods.CHAT_CLEAR_MESSAGE_RESPONSE]: HandleRoomClearMessageResponse,
  // [methods.CHAT_CONVERT_TO_GROUP_RESPONSE]: HandleChatConvertToGroupResponse,
  [methods.CHAT_DELETE_MESSAGE_RESPONSE]: HandleMessagesDeleteMessageResponse,
  [methods.CHAT_DELETE_RESPONSE]: HandleRoomDeleteResponse,
  [methods.CHAT_EDIT_MESSAGE_RESPONSE]: HandleMessagesEditMessageResponse,
  [methods.CHAT_GET_DRAFT_RESPONSE]: HandleRoomGetDraftResponse,
  [methods.CHAT_GET_ROOM_RESPONSE]: HandleClientGetRoomResponse,
  [methods.CHAT_SEND_MESSAGE_RESPONSE]: HandleRoomSendMessageResponse,
  [methods.CHAT_SET_ACTION_RESPONSE]: HandleRoomSetActionResponse,
  [methods.CHAT_UPDATE_DRAFT_RESPONSE]: HandleRoomUpdateDraftResponse,
  [methods.CHAT_UPDATE_STATUS_RESPONSE]: HandleRoomUpdateStatusResponse,
  // [methods.CLIENT_CHECK_INVITE_LINK_RESPONSE]: HandleClientCheckInviteLinkResponse,
  // [methods.CLIENT_CONDITION_RESPONSE]: HandleClientConditionResponse,
  // [methods.CLIENT_COUNT_ROOM_HISTORY_RESPONSE]: HandleClientCountRoomHistoryResponse,
  [methods.CLIENT_GET_DISCOVERY_RESPONSE]: HandleClientGetDiscoveryResponse,
  // [methods.CLIENT_GET_FAVORITE_MENU_RESPONSE]: HandleClientGetFavoriteMenuResponse,
  [methods.CLIENT_GET_POLL_RESPONSE]: HandleClientGetPollResponse,
  [methods.CLIENT_GET_PROMOTE_RESPONSE]: HandleClientGetPromoteResponse,
  [methods.CLIENT_GET_ROOM_HISTORY_RESPONSE]: HandleClientGetRoomHistoryResponse,
  [methods.CLIENT_GET_ROOM_LIST_RESPONSE]: HandleClientGetRoomListResponse,
  [methods.CLIENT_GET_ROOM_MESSAGE_RESPONSE]: HandleClientGetRoomMessageResponse,
  [methods.CLIENT_GET_ROOM_RESPONSE]: HandleClientGetRoomResponse,
  // [methods.CLIENT_JOIN_BY_INVITE_LINK_RESPONSE]: HandleClientJoinByInviteLinkResponse,
  [methods.CLIENT_JOIN_BY_USERNAME_RESPONSE]: HandleClientJoinByUsernameResponse,
  [methods.CLIENT_MUTE_ROOM_RESPONSE]: HandleClientMuteRoomResponse,
  [methods.CLIENT_PIN_ROOM_RESPONSE]: HandleClientPinRoomResponse,
  // [methods.CLIENT_REGISTER_DEVICE_RESPONSE]: HandleClientRegisterDeviceResponse,
  [methods.CLIENT_RESOLVE_USERNAME_RESPONSE]: HandleClientResolveUsernameResponse,
  // [methods.CLIENT_ROOM_REPORT_RESPONSE]: HandleClientRoomReportResponse,
  [methods.CLIENT_SEARCH_ROOM_HISTORY_RESPONSE]: HandleClientSearchRoomHistoryResponse,
  // [methods.CLIENT_SEARCH_USERNAME_RESPONSE]: HandleClientSearchUsernameResponse,
  // [methods.CLIENT_SET_DISCOVERY_ITEM_AGREEMENT_RESPONSE]: HandleClientSetDiscoveryItemAgreementResponse,
  // [methods.CLIENT_SET_DISCOVERY_ITEM_CLICK_RESPONSE]: HandleClientSetDiscoveryItemClickResponse,
  [methods.CLIENT_UNSUBSCRIBE_FROM_ROOM_RESPONSE]: HandleClientUnsubscribeFromRoomResponse,
  [methods.CONNECTION_SECURING_RESPONSE]: HandleConnectionSecuringResponse,
  [methods.CONNECTION_SYMMETRIC_KEY_RESPONSE]: HandleConnectionSymmetricKeyResponse,
  [methods.ERROR_RESPONSE]: HandleErrorResponse,
  // [methods.FILE_DOWNLOAD_RESPONSE]: HandleFileDownloadResponse,
  // [methods.FILE_INFO_RESPONSE]: HandleFileInfoResponse,
  // [methods.FILE_UPLOAD_INIT_RESPONSE]: HandleFileUploadInitResponse,
  // [methods.FILE_UPLOAD_OPTION_RESPONSE]: HandleFileUploadOptionResponse,
  // [methods.FILE_UPLOAD_RESPONSE]: HandleFileUploadResponse,
  // [methods.FILE_UPLOAD_STATUS_RESPONSE]: HandleFileUploadStatusResponse,
  // [methods.GEO_GET_COMMENT_RESPONSE]: HandleGeoGetCommentResponse,
  // [methods.GEO_GET_CONFIGURATION_RESPONSE]: HandleGeoGetConfigurationResponse,
  // [methods.GEO_GET_NEARBY_COORDINATE_RESPONSE]: HandleGeoGetNearbyCoordinateResponse,
  // [methods.GEO_GET_NEARBY_DISTANCE_RESPONSE]: HandleGeoGetNearbyDistanceResponse,
  // [methods.GEO_GET_REGISTER_STATUS_RESPONSE]: HandleGeoGetRegisterStatusResponse,
  // [methods.GEO_REGISTER_RESPONSE]: HandleGeoRegisterResponse,
  // [methods.GEO_UPDATE_COMMENT_RESPONSE]: HandleGeoUpdateCommentResponse,
  // [methods.GEO_UPDATE_POSITION_RESPONSE]: HandleGeoUpdatePositionResponse,
  [methods.GROUP_ADD_ADMIN_RESPONSE]: HandleRoomAddAdminResponse,
  [methods.GROUP_ADD_MEMBER_RESPONSE]: HandleRoomAddMemberResponse,
  // [methods.GROUP_ADD_MODERATOR_RESPONSE]: HandleGroupAddModeratorResponse,
  [methods.GROUP_AVATAR_ADD_RESPONSE]: HandleGroupAvatarAddResponse,
  // [methods.GROUP_AVATAR_DELETE_RESPONSE]: HandleGroupAvatarDeleteResponse,
  [methods.GROUP_AVATAR_GET_LIST_RESPONSE]: HandleRoomAvatarGetListResponse,
  [methods.GROUP_CHANGE_MEMBER_RIGHTS_RESPONSE]: HandleGroupChangeMemberRightsResponse,
  // [methods.GROUP_CHECK_USERNAME_RESPONSE]: HandleGroupCheckUsernameResponse,
  [methods.GROUP_CLEAR_MESSAGE_RESPONSE]: HandleRoomClearMessageResponse,
  [methods.GROUP_CREATE_RESPONSE]: HandleRoomAddMemberResponse,
  [methods.GROUP_DELETE_MESSAGE_RESPONSE]: HandleMessagesDeleteMessageResponse,
  [methods.GROUP_DELETE_RESPONSE]: HandleRoomDeleteResponse,
  [methods.GROUP_EDIT_MESSAGE_RESPONSE]: HandleMessagesEditMessageResponse,
  [methods.GROUP_EDIT_RESPONSE]: HandleRoomEditResponse,
  [methods.GROUP_GET_DRAFT_RESPONSE]: HandleRoomGetDraftResponse,
  [methods.GROUP_GET_MEMBER_LIST_RESPONSE]: HandleRoomGetMemberListResponse,
  [methods.GROUP_KICK_ADMIN_RESPONSE]: HandleRoomKickAdminResponse,
  [methods.GROUP_KICK_MEMBER_RESPONSE]: HandleRoomLeftResponse,
  // [methods.GROUP_KICK_MODERATOR_RESPONSE]: HandleGroupKickModeratorResponse,
  [methods.GROUP_LEFT_RESPONSE]: HandleRoomLeftResponse,
  [methods.GROUP_PIN_MESSAGE_RESPONSE]: HandleRoomPinMessageResponse,
  // [methods.GROUP_REMOVE_USERNAME_RESPONSE]: HandleGroupRemoveUsernameResponse,
  // [methods.GROUP_REVOKE_LINK_RESPONSE]: HandleGroupRevokeLinkResponse,
  [methods.GROUP_SEND_MESSAGE_RESPONSE]: HandleRoomSendMessageResponse,
  [methods.GROUP_SET_ACTION_RESPONSE]: HandleRoomSetActionResponse,
  [methods.GROUP_UPDATE_DRAFT_RESPONSE]: HandleRoomUpdateDraftResponse,
  [methods.GROUP_UPDATE_STATUS_RESPONSE]: HandleRoomUpdateStatusResponse,
  [methods.GROUP_UPDATE_USERNAME_RESPONSE]: HandleRoomUpdateUsernameResponse,
  // [methods.HEARTBEAT_RESPONSE]: HandleHeartbeatResponse,
  [methods.INFO_CONFIG_RESPONSE]: HandleInfoConfigResponse,
  [methods.INFO_UPDATE_RESPONSE]: HandleInfoUpdateResponse,
  // [methods.INFO_COUNTRY_RESPONSE]: HandleInfoCountryResponse,
  // [methods.INFO_LOCATION_RESPONSE]: HandleInfoLocationResponse,
  // [methods.INFO_PAGE_RESPONSE]: HandleInfoPageResponse,
  // [methods.INFO_TIME_RESPONSE]: HandleInfoTimeResponse,
  // [methods.INFO_WALLPAPER_RESPONSE]: HandleInfoWallpaperResponse,
  // [methods.MPL_GET_BILL_TOKEN_RESPONSE]: HandleMplGetBillTokenResponse,
  // [methods.MPL_GET_SALES_TOKEN_RESPONSE]: HandleMplGetSalesTokenResponse,
  // [methods.MPL_GET_TOPUP_TOKEN_RESPONSE]: HandleMplGetTopupTokenResponse,
  [methods.PUSH_LOGIN_TOKEN_RESPONSE]: HandlePushLoginTokenResponse,
  // [methods.PUSH_RATE_SIGNALING_RESPONSE]: HandlePushRateSignalingResponse,
  [methods.PUSH_TWO_STEP_VERIFICATION_RESPONSE]: HandlePushTwoStepVerificationResponse,
  // [methods.PUSH_USER_INFO_EXPIRED_RESPONSE]: HandlePushUserInfoExpiredResponse,
  // [methods.PUSH_WALLET_PAYMENT_VERIFIED_RESPONSE]: HandlePushWalletPaymentVerifiedResponse,
  // [methods.QR_CODE_ADD_CONTACT_RESPONSE]: HandleQrCodeAddContactResponse,
  // [methods.QR_CODE_ADD_ME_RESPONSE]: HandleQrCodeAddMeResponse,
  // [methods.QR_CODE_JOIN_RESPONSE]: HandleQrCodeJoinResponse,
  // [methods.QR_CODE_NEW_DEVICE_RESPONSE]: HandleQrCodeNewDeviceResponse,
  // [methods.QR_CODE_RESOLVE_RESPONSE]: HandleQrCodeResolveResponse,
  [methods.SIGNALING_ACCEPT_RESPONSE]: HandleSignalingAcceptResponse,
  [methods.SIGNALING_CANDIDATE_RESPONSE]: HandleSignalingCandidateResponse,
  // [methods.SIGNALING_CLEAR_LOG_RESPONSE]: HandleSignalingClearLogResponse,
  [methods.SIGNALING_GET_CONFIGURATION_RESPONSE]: HandleSignalingGetConfigurationResponse,
  [methods.SIGNALING_GET_LOG_RESPONSE]: HandleSignalingGetLogResponse,
  [methods.SIGNALING_LEAVE_RESPONSE]: HandleSignalingLeaveResponse,
  [methods.SIGNALING_OFFER_RESPONSE]: HandleSignalingOfferResponse,
  // [methods.SIGNALING_RATE_RESPONSE]: HandleSignalingRateResponse,
  [methods.SIGNALING_RINGING_RESPONSE]: HandleSignalingRingingResponse,
  [methods.SIGNALING_SESSION_HOLD_RESPONSE]: HandleSignalingSessionHoldResponse,
  [methods.USER_AVATAR_ADD_RESPONSE]: HandleUserAddAvatarResponse,
  [methods.USER_AVATAR_DELETE_RESPONSE]: HandleUserAvatarDeleteResponse,
  [methods.USER_AVATAR_GET_LIST_RESPONSE]: HandleRoomAvatarGetListResponse,
  [methods.USER_CONTACTS_BLOCK_RESPONSE]: HandleUserContactsBlockResponse,
  [methods.USER_CONTACTS_DELETE_RESPONSE]: HandleUserContactsDeleteResponse,
  [methods.USER_CONTACTS_EDIT_RESPONSE]: HandleUserContactsEditResponse,
  [methods.USER_CONTACTS_GET_BLOCKED_LIST_RESPONSE]: HandleUserContactsGetBlockedListResponse,
  [methods.USER_CONTACTS_GET_LIST_RESPONSE]: HandleUserContactsGetListResponse,
  [methods.USER_CONTACTS_IMPORT_RESPONSE]: HandleUserContactsImportResponse,
  [methods.USER_CONTACTS_UNBLOCK_RESPONSE]: HandleUserContactsUnblockResponse,
  [methods.USER_DELETE_RESPONSE]: HandleUserDeleteResponse,
  // [methods.USER_GET_DELETE_TOKEN_RESPONSE]: HandleUserGetDeleteTokenResponse,
  [methods.USER_INFO_RESPONSE]: HandleUserInfoResponse,
  // [methods.USER_IVAND_GET_ACTIVITIES_RESPONSE]: HandleUserIvandGetActivitiesResponse,
  [methods.USER_IVAND_GET_SCORE_RESPONSE]: HandleUserIVandGetScoreResponse,
  // [methods.USER_IVAND_SET_ACTIVITY_RESPONSE]: HandleUserIvandSetActivityResponse,
  [methods.USER_LOGIN_RESPONSE]: HandleUserLoginResponse,
  // [methods.USER_PRIVACY_GET_RULE_RESPONSE]: HandleUserPrivacyGetRuleResponse,
  // [methods.USER_PRIVACY_SET_RULE_RESPONSE]: HandleUserPrivacySetRuleResponse,
  // [methods.USER_PROFILE_CHECK_USERNAME_RESPONSE]: HandleUserProfileCheckUsernameResponse,
  // [methods.USER_PROFILE_GET_BIO_RESPONSE]: HandleUserProfileGetBioResponse,
  // [methods.USER_PROFILE_GET_EMAIL_RESPONSE]: HandleUserProfileGetEmailResponse,
  // [methods.USER_PROFILE_GET_GENDER_RESPONSE]: HandleUserProfileGetGenderResponse,
  // [methods.USER_PROFILE_GET_NICKNAME_RESPONSE]: HandleUserProfileGetNicknameResponse,
  // [methods.USER_PROFILE_GET_REPRESENTATIVE_RESPONSE]: HandleUserProfileGetRepresentativeResponse,
  // [methods.USER_PROFILE_GET_SELF_REMOVE_RESPONSE]: HandleUserProfileGetSelfRemoveResponse,
  [methods.USER_PROFILE_SET_BIO_RESPONSE]: HandleUserProfileSetBioResponse,
  // [methods.USER_PROFILE_SET_EMAIL_RESPONSE]: HandleUserProfileSetEmailResponse,
  // [methods.USER_PROFILE_SET_GENDER_RESPONSE]: HandleUserProfileSetGenderResponse,
  [methods.USER_PROFILE_SET_NICKNAME_RESPONSE]: HandleUserProfileSetNicknameResponse,
  // [methods.USER_PROFILE_SET_REPRESENTATIVE_RESPONSE]: HandleUserProfileSetRepresentativeResponse,
  // [methods.USER_PROFILE_SET_SELF_REMOVE_RESPONSE]: HandleUserProfileSetSelfRemoveResponse,
  [methods.USER_PROFILE_UPDATE_USERNAME_RESPONSE]: HandleUserProfileUpdateUsernameResponse,
  [methods.USER_REGISTER_RESPONSE]: HandleUserRegisterResponse,
  // [methods.USER_REPORT_RESPONSE]: HandleUserReportResponse,
  // [methods.USER_SESSION_GET_ACTIVE_LIST_RESPONSE]: HandleUserSessionGetActiveListResponse,
  // [methods.USER_SESSION_LOGOUT_RESPONSE]: HandleUserSessionLogoutResponse,
  // [methods.USER_SESSION_TERMINATE_RESPONSE]: HandleUserSessionTerminateResponse,
  // [methods.USER_SET_BOT_RESPONSE]: HandleUserSetBotResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_CHANGE_HINT_RESPONSE]: HandleUserTwoStepVerificationChangeHintResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_RESPONSE]: HandleUserTwoStepVerificationChangeRecoveryEmailResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_RESPONSE]: HandleUserTwoStepVerificationChangeRecoveryQuestionResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_RESPONSE]: HandleUserTwoStepVerificationCheckPasswordResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_RESPONSE]: HandleUserTwoStepVerificationGetPasswordDetailResponse,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_RESPONSE]: HandleUserTwoStepVerificationRecoverPasswordByAnswersResponse,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_RESPONSE]: HandleUserTwoStepVerificationRecoverPasswordByTokenResponse,
  [methods.USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_RESPONSE]: HandleUserTwoStepVerificationRequestRecoveryTokenResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_RESPONSE]: HandleUserTwoStepVerificationResendVerifyEmailResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_SET_PASSWORD_RESPONSE]: HandleUserTwoStepVerificationSetPasswordResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_RESPONSE]: HandleUserTwoStepVerificationUnsetPasswordResponse,
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_RESPONSE]: HandleUserTwoStepVerificationVerifyPasswordResponse,
  // [methods.USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_RESPONSE]: HandleUserTwoStepVerificationVerifyRecoveryEmailResponse,
  [methods.USER_UPDATE_STATUS_RESPONSE]: HandleUserUpdateStatusResponse,
  // [methods.USER_USERNAME_TO_ID_RESPONSE]: HandleUserUsernameToIdResponse,
  // [methods.USER_VERIFY_NEW_DEVICE_RESPONSE]: HandleUserVerifyNewDeviceResponse,
  [methods.USER_VERIFY_RESPONSE]: HandleUserVerifyResponse,
  // [methods.WALLET_GET_ACCESS_TOKEN_RESPONSE]: HandleWalletGetAccessTokenResponse,
  // [methods.WALLET_ID_MAPPING_RESPONSE]: HandleWalletIdMappingResponse,
  // [methods.WALLET_PAYMENT_INIT_RESPONSE]: HandleWalletPaymentInitResponse,
  // [methods.WALLET_REGISTER_RESPONSE]: HandleWalletRegisterResponse,
  [methods.STORY_GET_STORIES_RESPONSE]: HandleStoryGetStoriesResponse,
  [methods.STORY_ADD_STORIES_RESPONSE]: HandleStoryUserAddNewResponse,
  [methods.STORY_ADD_VIEW_RESPONSE]: HandleStoryAddViewResponse,
  [methods.STORY_GET_OWN_STORY_VIEWS_RESPONSE]: HandleStoryGetOwnStoryViewsResponse,
  [methods.STORY_DELETE_STORY_RESPONSE]: HandleStoryDeleteStoryResponse,
  [methods.CLIENT_ROOM_CHANGE_OWNER_RESPONSE]: HandleClientRoomChangeOwner,
  [methods.CLIENT_ROOM_MEMBER_SEARCH_RESPONSE]: HandleClientRoomMemberSearchResponse,
};

export default handlerTable;
